/* =========================================================
   HOMEPAGE SHARK TANK — SHARED ATC HELPER
   Per feedback_picker_must_fire_pixels.md (2026-05-31):
   Any custom picker fetching /cart/add.js MUST fire:
     - fbq('track', 'AddToCart', ...)
     - dataLayer.push({event:'add_to_cart',...})
     - webPixelsManager.publish('product_added_to_cart', ...)
     - ttq.track('AddToCart', ...)
     - dispatch cart:item-added CustomEvent
   Also refreshes cart drawer counters if theme exposes them.
   ========================================================= */
(function () {
  'use strict';
  if (window.HST_ATC) return;

  function fireTrackingEvents(payload) {
    // payload = { id, quantity, price (cents), title, variantTitle, url }
    try {
      var value = (payload.price / 100) * payload.quantity;

      // Meta Pixel
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', {
          content_ids: [String(payload.id)],
          content_name: payload.title,
          content_type: 'product',
          contents: [{ id: String(payload.id), quantity: payload.quantity }],
          currency: 'USD',
          value: value
        });
      }

      // GA4 dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: value,
          items: [{
            item_id: String(payload.id),
            item_name: payload.title,
            item_variant: payload.variantTitle || '',
            price: payload.price / 100,
            quantity: payload.quantity
          }]
        }
      });

      // Shopify Web Pixels
      if (window.webPixelsManager && typeof window.webPixelsManager.publish === 'function') {
        window.webPixelsManager.publish('product_added_to_cart', {
          cartLine: {
            merchandise: {
              id: String(payload.id),
              title: payload.variantTitle || '',
              product: { id: String(payload.id), title: payload.title, url: payload.url || '' },
              price: { amount: payload.price / 100, currencyCode: 'USD' }
            },
            quantity: payload.quantity
          }
        });
      }

      // TikTok Pixel
      if (typeof window.ttq !== 'undefined' && typeof window.ttq.track === 'function') {
        window.ttq.track('AddToCart', {
          content_id: String(payload.id),
          content_name: payload.title,
          content_type: 'product',
          quantity: payload.quantity,
          price: payload.price / 100,
          value: value,
          currency: 'USD'
        });
      }

      // Native theme events
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: payload, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.warn('[HST_ATC] tracking event error', err);
    }
  }

  /* Add a single item to cart via /cart/add.js, then fire pixels + refresh drawer. */
  function addToCart(item, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add.js status ' + r.status);
        return r.json();
      })
      .then(function (res) {
        var line = (res && res.items && res.items[0]) || res;
        var payload = {
          id: item.id,
          quantity: item.quantity || 1,
          price: line.price || item.priceCents || 0,
          title: line.product_title || item.title || '',
          variantTitle: line.variant_title || item.variantTitle || '',
          url: line.url || ''
        };
        fireTrackingEvents(payload);
        if (!opts.skipToast) toast('Added ' + payload.quantity + '× ' + payload.title + ' to cart');
        if (!opts.skipRedirect && opts.redirectToCart) {
          window.location.href = '/cart';
        }
        return res;
      })
      .catch(function (err) {
        console.error('[HST_ATC]', err);
        toast('Could not add to cart. Please try again.', true);
        throw err;
      });
  }

  /* Toast — a shared UI helper. */
  function toast(msg, isError) {
    var el = document.getElementById('hst-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'hst-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'position:fixed;bottom:100px;left:50%;transform:translateX(-50%) translateY(20px);' +
        'background:#63FF00;color:#000;padding:12px 20px;font-weight:800;font-size:13px;' +
        'letter-spacing:0.06em;text-transform:uppercase;border-radius:4px;' +
        'box-shadow:0 10px 30px rgba(99,255,0,0.35);opacity:0;pointer-events:none;' +
        'transition:opacity 0.25s,transform 0.25s;z-index:9999;font-family:Archivo,sans-serif;';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.background = isError ? '#ff3b3b' : '#63FF00';
    el.style.color = isError ? '#fff' : '#000';
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2200);
  }

  window.HST_ATC = {
    addToCart: addToCart,
    fireTrackingEvents: fireTrackingEvents,
    toast: toast
  };
})();
